import React from 'react';
import { motion } from 'framer-motion';
import { Heart, MessageCircle, Baby, Activity } from 'lucide-react';

const PetHumanConnection: React.FC = () => {
  const benefits = [
    {
      icon: <Heart className="w-6 h-6 text-primary" />,
      title: 'Relație emoțională',
      description: 'Legătura emoțională dintre câinele și stăpânul care profund se dezvoltă este adesea recunoscută',
      image: 'https://images.pexels.com/photos/1254140/pexels-photo-1254140.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
    },
    {
      icon: <MessageCircle className="w-6 h-6 text-primary" />,
      title: 'Comunicare',
      description: 'Animalele pot comunica mai bine cu oamenii în cazul în care pot să învețe comenzi și se poate stabili o comunicare non-verbală',
      image: 'https://images.pexels.com/photos/1254140/pexels-photo-1254140.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
    },
    {
      icon: <Baby className="w-6 h-6 text-primary" />,
      title: 'Copii și animale',
      description: 'Animalele de companie stabilesc atașamente emoționale față la copii, având o influență pozitivă în termeni de aspecte afective și considerație reciprocă',
      image: 'https://images.pexels.com/photos/1254140/pexels-photo-1254140.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
    },
    {
      icon: <Activity className="w-6 h-6 text-primary" />,
      title: 'Sănătate',
      description: 'Unele studii sugerează că deținerea unui animal de companie poate ajuta la reducerea stresului și la îmbunătățirea sănătății mentale',
      image: 'https://images.pexels.com/photos/1254140/pexels-photo-1254140.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      <div className="md:col-span-1">
        <motion.img
          src="/peaceful-coexistence.jpg"
          alt="Conviețuire pașnică între oameni și animale"
          className="rounded-lg shadow-lg w-full h-auto object-cover"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        />
      </div>
      
      <div className="md:col-span-2">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              className="bg-white p-6 rounded-lg shadow-md"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <div className="flex items-start mb-4">
                <div className="bg-primary-100 p-3 rounded-full mr-4">
                  {benefit.icon}
                </div>
                <div>
                  <h3 className="font-bold text-primary text-lg mb-2">{benefit.title}</h3>
                  <p className="text-gray-600 text-sm">{benefit.description}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PetHumanConnection;